// extracted by mini-css-extract-plugin
export default {"container":"MissionChoiceBox_container__1anz1","title":"MissionChoiceBox_title__LozQY","arrow":"MissionChoiceBox_arrow__0OP08","content":"MissionChoiceBox_content__+o+5F"};